const en = {
  collapsePlayer: "Collapse player",
  expandPlayer: "Expand player",
  currentTrack: "Current track",
  programmeAudio: "Programme audio",
  listenDevices: "Listen on a device",
  thisDevice: "Audio output: this device",
  wirelessConnected: "Connected to a wireless device",
  deviceConnecting: "Connecting…",
  airplayHint:
    "Choose an AirPlay speaker or TV on your network. Availability depends on your browser and device.",
  airplaySafari: "Open this page in Safari on an Apple device to use AirPlay.",
  chooseAirplay: "Choose AirPlay device",
  chooseDevice: "Choose a wireless device",
  castLocal:
    "This local preview’s audio is only available on this computer. To listen on a Chromecast, cast this tab from Google Chrome.",
  castBrowser:
    "Use your browser’s wireless picker when available, or cast this tab from Google Chrome.",
  castTab: "Cast this tab with Chrome",
  castStepOne:
    "Open this page in Google Chrome. Connect your computer and Chromecast to the same Wi-Fi network.",
  castStepTwo: "Open Chrome’s menu → Cast, save, and share → Cast.",
  castStepThree:
    "Choose Cast tab and select your speaker or TV. Keep this tab open while listening.",
  castHelp: "Google’s casting guide",
  noDevices:
    "No compatible devices found yet. Check that both devices use the same network.",
  deviceFailed:
    "The device picker could not open. Try Safari for AirPlay, or Chrome’s Cast tab option.",
  followShort: "Follow",
  frequencyView: "Frequency view",
  seekSpeech: "Seek in Speech",
  seekMusic: "Seek in Music",
  playerGuide: "Player controls & guide",
  zoom: "Time zoom",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out",
  fit: "Fit",
  panTimeline: "Pan the visible time range",
  spectrumSettings: "Spectrum controls & guide",
  frequencyScale: "Frequency scale",
  logarithmic: "Logarithmic",
  linear: "Linear",
  frequencyRange: "Frequency range",
  spectrumAveraged: "Time-averaged level from the recorded audio.",
  spectrumHelp:
    "Click to seek. Drag to pan. Use + / − to zoom, arrow keys to seek, Shift + arrows to pan, and Ctrl + wheel to zoom at the pointer. The overview moves the visible time range.",
  spectrumCursor:
    "Move over the spectrum to inspect time, frequency and level.",
  loadingSpectrum: "Loading spectrum…",
  spectrumUnavailable:
    "Frequency analysis is unavailable for this recording. Playback still works.",
  liveSubtitles: "Live subtitles",
  bandcamp: "Find on Bandcamp",
  copyFailed: "Could not copy the link. Copy the address from your browser.",
  navigation: "Navigation",

  wheelShows: "The listening wheel",
  circlePlayHint: "Choose a circle, then tap it again to play",
  allShows: "All shows",
  fromCollection: "From the collection",
  rotateHint: "Drag the wheel or choose a show",
  browse: "Browse",
  thisWeek: "This week",
  weeklyShows: "This week’s new shows",
  onTheDial: "On the dial",
  previousShow: "Previous show",
  nextShow: "Next show",
  pauseRotation: "Pause rotation",
  startRotation: "Start rotation",
  selectShow: "Choose show",
  weeklyHint: "A turn of the dial. A different corner of the world.",
  emptyWeek:
    "No broadcasts dated this week yet. Explore the collection while we tune in.",
  previousSection: "Previous section",
  nextSection: "Next section",
  appearance: "Appearance & accessibility",
  layout: "Layout",
  identity: "Name & logo",
  fontFace: "Font face",
  textSize: "Text size",
  palette: "Colour palette",
  motion: "Motion",
  readingComfort: "Reading comfort",
  preview: "Live preview",
  previewTitle: "A little further from the familiar.",
  resetAppearance: "Reset reading preferences",
  appearanceSaved: "Changes are saved to your account.",
  appearanceLocal:
    "Changes are saved on this device. Sign in to keep them with your account.",
  fontEditorial: "Editorial · mixed type",
  fontSans: "System sans · clean",
  fontHumanist: "Verdana · open letterforms",
  fontSerif: "Georgia · serif",
  fontMono: "Monospace · even spacing",
  palette_theme: "Layout palette",
  palette_linen: "Linen · warm paper",
  palette_ocean: "Ocean · blue & cream",
  palette_plum: "Plum · soft violet",
  palette_night: "Night · dark ink",
  systemMotion: "Follow device setting",
  reducedMotion: "Reduce motion",
  contrast: "High contrast",
  spacing: "More line & letter spacing",
  underline: "Underline links",
  followPlayback: "Follow playback automatically",
  preferenceError: "Saved on this device; account sync failed.",
  atlas: "A field guide to the airwaves",
  tide: "A flowing listening shelf",
  musicLabel: "Music",
  timeline: "Audio map",
  speechMusic: "Speech over music",
  unclassified: "Unclassified sound",
  timelineHint:
    "Detected sections. Speech and music may overlap; choose a section to listen.",
  trackFollow: "Follow current track",
  transcriptHint: "Read along, or choose a line to return to that moment.",
  skipContent: "Skip to content",
  discover: "Discover",
  new: "What’s new",
  shows: "Shows",
  stations: "Stations",
  artists: "Artists",
  search: "Search",
  library: "My listening",
  signin: "Sign in",
  signout: "Sign out",
  settings: "Your space",
  headline: "Adventurous music.\nFrom around the world.",
  intro:
    "Public radio and independent voices. Adventurous music selected by people, not algorithms. Follow the ears of presenters who know and love what they play.",
  eyebrow: "ADVENTUROUS PUBLIC RADIO FROM AROUND THE WORLD",
  latest: "Latest arrivals",
  all: "All programmes",
  listen: "Listen now",
  play: "Play",
  pause: "Pause",
  queue: "Add to queue",
  added: "Added to queue",
  episodes: "episodes",
  episode: "Episode",
  minutes: "min",
  featured: "A place to begin",
  explore: "Explore the collection",
  tracks: "Tracklist",
  transcript: "Transcript",
  notes: "Private notes",
  about: "About this episode",
  original: "Original",
  translation: "Translation",
  bilingual: "Show original too",
  follow: "Follow playback",
  caption: "Now being said",
  music: "Let the music speak.",
  musicHint: "Captions appear when someone speaks.",
  listening: "Now listening",
  openPlayer: "Open full player",
  speech: "Speech",
  sound: "Music & sound",
  estimated: "Estimated",
  candidate: "Suggested · unconfirmed",
  publisher: "Publisher tracklist",
  confirmed: "Confirmed",
  unknown: "Unidentified piece",
  language: "Reading language",
  themes: "Choose your perspective",
  themeHint: "Five layouts. Your way to listen.",
  folio: "An editorial listening journal",
  signal: "An after-hours listening console",
  gallery: "An open, graphic collection",
  languageHint:
    "Your language follows you through captions, transcripts, search and programme descriptions.",
  translated: "Automatically translated",
  translating: "Translating programme details…",
  unavailable: "Programme translation is unavailable. Original text is shown.",
  searchTitle: "Follow a thread.",
  searchHint:
    "Search artists, shows, stations, tracks or a phrase in any language.",
  searchPlaceholder: "An artist, a place, a passing thought…",
  results: "results",
  noResults: "Nothing found. Try another name or phrase.",
  newTitle: "Fresh signals.",
  newIntro:
    "Fresh programmes from public and independent radio. New sounds, chosen by curious people.",
  broadcast: "Broadcast date",
  addedDate: "Date added",
  connections: "Across the airwaves",
  guest: "Guest",
  appeared: "Heard on",
  showsTitle: "Voices worth returning to.",
  stationsTitle: "Different places. Shared curiosity.",
  artistsTitle: "People behind the sound.",
  saveNote: "Save private note",
  notePlaceholder: "A thought, a discovery, something to return to…",
  noteHint:
    "Only you can see these. Each note stays attached to this exact recording.",
  noNotes: "Your listening journal starts with a moment.",
  noteLogin: "Sign in to save a private note at this moment.",
  delete: "Delete",
  edit: "Edit",
  save: "Save",
  cancel: "Cancel",
  username: "Username",
  password: "Password",
  createAccount: "Create account",
  authIntro: "Keep your language, your perspective and your own notes.",
  demoHint:
    "A demo account is available. Its credentials are in the local demo-account.txt file.",
  loading: "Tuning in…",
  retry: "Try again",
  empty: "No programmes here yet.",
  source: "Visit original broadcast",
  duration: "Duration",
  languages: "Spoken languages",
  collection: "The collection",
  viewAll: "View all",
  next: "Next in queue",
  queueEmpty: "Your queue is clear. Add a programme to keep exploring.",
  clear: "Clear queue",
  remove: "Remove",
  back: "Back",
  close: "Close",
  volume: "Volume",
  speed: "Playback speed",
  skipBack: "Back 15 seconds",
  skipForward: "Forward 15 seconds",
  seek: "Playback position",
  account: "Account",
  working: "Adventurous music. Selected by people, not algorithms.",
  noArtist: "No artist information has been published for this piece.",
  details: "Programme details",
  focus: "Listening room",
  exitFocus: "Leave listening room",
  captionMissing: "Translation unavailable · showing original",
  automaticHint:
    "Transcripts and translations are automatic and may contain errors.",
  more: "Load more",
  copied: "Link copied",
  share: "Copy moment link",
  noteSaved: "Private note saved",
};
type Key = keyof typeof en;
const fr: Partial<Record<Key, string>> = {
  collapsePlayer: "Réduire le lecteur",
  expandPlayer: "Agrandir le lecteur",
  currentTrack: "Titre en cours",
  programmeAudio: "Audio de l’émission",
  listenDevices: "Écouter sur un appareil",
  thisDevice: "Sortie audio : cet appareil",
  wirelessConnected: "Appareil sans fil connecté",
  deviceConnecting: "Connexion…",
  airplayHint:
    "Choisissez une enceinte ou un téléviseur AirPlay sur votre réseau. La disponibilité dépend du navigateur et de l’appareil.",
  airplaySafari:
    "Ouvrez cette page dans Safari sur un appareil Apple pour utiliser AirPlay.",
  chooseAirplay: "Choisir un appareil AirPlay",
  chooseDevice: "Choisir un appareil sans fil",
  castLocal:
    "L’audio de cet aperçu local est accessible uniquement sur cet ordinateur. Pour écouter sur Chromecast, diffusez cet onglet depuis Google Chrome.",
  castBrowser:
    "Utilisez le sélecteur sans fil du navigateur si disponible, ou diffusez cet onglet depuis Google Chrome.",
  castTab: "Diffuser cet onglet avec Chrome",
  castStepOne:
    "Ouvrez cette page dans Google Chrome. Connectez l’ordinateur et le Chromecast au même réseau Wi-Fi.",
  castStepTwo:
    "Ouvrez le menu Chrome → Caster, enregistrer et partager → Caster.",
  castStepThree:
    "Choisissez Diffuser l’onglet et sélectionnez votre enceinte ou téléviseur. Gardez cet onglet ouvert pendant l’écoute.",
  castHelp: "Guide Google de diffusion",
  noDevices:
    "Aucun appareil compatible trouvé. Vérifiez que les deux appareils utilisent le même réseau.",
  deviceFailed:
    "Le sélecteur ne s’est pas ouvert. Essayez Safari pour AirPlay ou la diffusion d’onglet de Chrome.",
  followShort: "Suivre",
  frequencyView: "Vue des fréquences",
  seekSpeech: "Se déplacer dans la parole",
  seekMusic: "Se déplacer dans la musique",
  playerGuide: "Commandes et guide du lecteur",
  zoom: "Zoom temporel",
  zoomIn: "Agrandir",
  zoomOut: "Réduire",
  fit: "Tout",
  panTimeline: "Déplacer la plage temporelle visible",
  spectrumSettings: "Réglages et guide du spectre",
  frequencyScale: "Échelle des fréquences",
  logarithmic: "Logarithmique",
  linear: "Linéaire",
  frequencyRange: "Plage des fréquences",
  spectrumAveraged:
    "Niveau moyen dans le temps, calculé à partir de l’enregistrement.",
  spectrumHelp:
    "Cliquez pour écouter à cet instant. Glissez pour déplacer la vue. + / − : zoom ; flèches : position ; Maj + flèches : déplacer ; Ctrl + molette : zoom au pointeur. La vue d’ensemble déplace la plage visible.",
  spectrumCursor:
    "Survolez le spectre pour lire le temps, la fréquence et le niveau.",
  loadingSpectrum: "Chargement du spectre…",
  spectrumUnavailable:
    "L’analyse fréquentielle est indisponible. La lecture reste possible.",
  liveSubtitles: "Sous-titres en direct",
  bandcamp: "Chercher sur Bandcamp",
  copyFailed:
    "Impossible de copier le lien. Copiez l’adresse dans le navigateur.",
  navigation: "Navigation",

  wheelShows: "La roue des écoutes",
  circlePlayHint:
    "Choisissez un cercle, puis touchez-le à nouveau pour écouter",
  allShows: "Toutes les émissions",
  fromCollection: "Dans la collection",
  rotateHint: "Faites tourner la roue ou choisissez une émission",
  browse: "Parcourir",
  thisWeek: "Cette semaine",
  weeklyShows: "Les nouvelles émissions de la semaine",
  onTheDial: "Sur le cadran",
  previousShow: "Émission précédente",
  nextShow: "Émission suivante",
  pauseRotation: "Arrêter la rotation",
  startRotation: "Lancer la rotation",
  selectShow: "Choisir l’émission",
  weeklyHint: "Un tour de cadran. Un autre coin du monde.",
  emptyWeek:
    "Pas encore de diffusion datée de cette semaine. Explorez la collection en attendant.",
  previousSection: "Section précédente",
  nextSection: "Section suivante",
  appearance: "Apparence et accessibilité",
  layout: "Mise en page",
  identity: "Nom et logo",
  fontFace: "Police",
  textSize: "Taille du texte",
  palette: "Palette de couleurs",
  motion: "Animations",
  readingComfort: "Confort de lecture",
  preview: "Aperçu en direct",
  previewTitle: "Un peu plus loin des sentiers connus.",
  resetAppearance: "Réinitialiser la lecture",
  appearanceSaved: "Vos choix sont enregistrés dans votre compte.",
  appearanceLocal:
    "Vos choix sont enregistrés sur cet appareil. Connectez-vous pour les conserver dans votre compte.",
  fontEditorial: "Éditorial · polices mixtes",
  fontSans: "Sans serif · système",
  fontHumanist: "Verdana · lettres ouvertes",
  fontSerif: "Georgia · avec empattements",
  fontMono: "Chasse fixe · espacement régulier",
  palette_theme: "Palette du thème",
  palette_linen: "Lin · papier chaud",
  palette_ocean: "Océan · bleu et crème",
  palette_plum: "Prune · violet doux",
  palette_night: "Nuit · encre sombre",
  systemMotion: "Suivre l’appareil",
  reducedMotion: "Réduire les animations",
  contrast: "Contraste élevé",
  spacing: "Espacer les lignes et les lettres",
  underline: "Souligner les liens",
  followPlayback: "Suivre automatiquement la lecture",
  preferenceError:
    "Enregistré sur cet appareil ; synchronisation du compte impossible.",
  atlas: "Un guide des ondes",
  tide: "Une collection au fil de l’écoute",
  musicLabel: "Musique",
  timeline: "Carte sonore",
  speechMusic: "Parole sur musique",
  unclassified: "Son non classé",
  timelineHint:
    "Sections détectées. Parole et musique peuvent se superposer. Choisissez une section à écouter.",
  trackFollow: "Suivre le morceau en cours",
  transcriptHint:
    "Lisez en écoutant, ou choisissez une ligne pour revenir à ce moment.",
  skipContent: "Aller au contenu",
  discover: "Découvrir",
  new: "Nouveautés",
  shows: "Émissions",
  stations: "Stations",
  artists: "Artistes",
  search: "Rechercher",
  library: "Mes écoutes",
  signin: "Connexion",
  signout: "Déconnexion",
  settings: "Votre espace",
  headline: "Des musiques aventureuses.\nDu monde entier.",
  intro:
    "Radios publiques et voix indépendantes. Des musiques choisies par des personnes, pas des algorithmes. Suivez des passionnés qui connaissent et aiment ce qu’ils diffusent.",
  eyebrow: "LES RADIOS PUBLIQUES AVENTUREUSES DU MONDE ENTIER",
  latest: "Derniers ajouts",
  all: "Toutes les émissions",
  listen: "Écouter",
  play: "Lire",
  pause: "Pause",
  queue: "Ajouter à la file",
  added: "Ajouté à la file",
  episodes: "épisodes",
  episode: "Épisode",
  featured: "Pour commencer",
  explore: "Explorer la collection",
  tracks: "Morceaux",
  transcript: "Transcription",
  notes: "Notes privées",
  about: "À propos de cet épisode",
  original: "Original",
  translation: "Traduction",
  bilingual: "Afficher aussi l’original",
  follow: "Suivre la lecture",
  caption: "En ce moment",
  music: "Laissons parler la musique.",
  musicHint: "Les sous-titres apparaissent pendant les paroles.",
  listening: "À l’écoute",
  openPlayer: "Ouvrir le lecteur",
  speech: "Parole",
  sound: "Musique et sons",
  candidate: "Suggestion · non confirmée",
  publisher: "Liste de la station",
  confirmed: "Confirmé",
  unknown: "Morceau non identifié",
  language: "Langue de lecture",
  themes: "Choisissez votre perspective",
  themeHint: "Cinq mises en page. Votre façon d’écouter.",
  languageHint:
    "Votre langue s’applique aux sous-titres, transcriptions, recherches et descriptions.",
  translated: "Traduction automatique",
  translating: "Traduction des descriptions…",
  unavailable: "Traduction indisponible. Texte original affiché.",
  searchTitle: "Suivez un fil.",
  searchHint:
    "Cherchez un artiste, une émission, un morceau ou une phrase dans toute langue.",
  searchPlaceholder: "Un artiste, un lieu, une idée…",
  results: "résultats",
  noResults: "Aucun résultat. Essayez un autre mot.",
  newTitle: "De nouveaux signaux.",
  newIntro: "Nouveaux ajouts et liens à travers la collection.",
  broadcast: "Date de diffusion",
  addedDate: "Date d’ajout",
  connections: "À travers les ondes",
  guest: "Invité",
  appeared: "Entendu sur",
  showsTitle: "Des voix à retrouver.",
  stationsTitle: "Des lieux différents. Une curiosité partagée.",
  artistsTitle: "Les personnes derrière le son.",
  saveNote: "Enregistrer la note privée",
  notePlaceholder: "Une pensée, une découverte, un instant à retrouver…",
  noteHint: "Vous seul pouvez voir ces notes, attachées à cet enregistrement.",
  noNotes: "Votre journal commence par un instant.",
  noteLogin: "Connectez-vous pour enregistrer une note privée.",
  delete: "Supprimer",
  edit: "Modifier",
  save: "Enregistrer",
  cancel: "Annuler",
  username: "Nom d’utilisateur",
  password: "Mot de passe",
  createAccount: "Créer un compte",
  authIntro: "Retrouvez votre langue, votre perspective et vos notes.",
  loading: "Connexion aux ondes…",
  retry: "Réessayer",
  empty: "Aucune émission ici pour le moment.",
  source: "Émission originale",
  duration: "Durée",
  languages: "Langues parlées",
  collection: "La collection",
  viewAll: "Tout voir",
  next: "À suivre",
  queueEmpty: "La file est vide. Ajoutez une émission.",
  clear: "Vider la file",
  remove: "Retirer",
  close: "Fermer",
  volume: "Volume",
  speed: "Vitesse de lecture",
  skipBack: "Reculer de 15 secondes",
  skipForward: "Avancer de 15 secondes",
  seek: "Position de lecture",
  account: "Compte",
  details: "Détails de l’émission",
  focus: "Salon d’écoute",
  exitFocus: "Quitter le salon",
  captionMissing: "Traduction indisponible · original affiché",
  automaticHint:
    "Les transcriptions et traductions automatiques peuvent contenir des erreurs.",
  more: "Voir plus",
  copied: "Lien copié",
  share: "Copier le lien de cet instant",
  noteSaved: "Note privée enregistrée",
};
const ar: Partial<Record<Key, string>> = {
  collapsePlayer: "طي مشغّل الصوت",
  expandPlayer: "توسيع مشغّل الصوت",
  currentTrack: "المقطع الحالي",
  programmeAudio: "صوت البرنامج",
  listenDevices: "الاستماع على جهاز",
  thisDevice: "مخرج الصوت: هذا الجهاز",
  wirelessConnected: "متصل بجهاز لاسلكي",
  deviceConnecting: "جارٍ الاتصال…",
  airplayHint:
    "اختر مكبر صوت أو تلفاز AirPlay على شبكتك. يعتمد التوفر على المتصفح والجهاز.",
  airplaySafari: "افتح هذه الصفحة في Safari على جهاز Apple لاستخدام AirPlay.",
  chooseAirplay: "اختيار جهاز AirPlay",
  chooseDevice: "اختيار جهاز لاسلكي",
  castLocal:
    "صوت هذه المعاينة المحلية متاح على هذا الحاسوب فقط. للاستماع على Chromecast، بث علامة التبويب هذه من Google Chrome.",
  castBrowser:
    "استخدم منتقي الأجهزة اللاسلكية في المتصفح إن توفر، أو بث علامة التبويب من Google Chrome.",
  castTab: "بث علامة التبويب باستخدام Chrome",
  castStepOne:
    "افتح الصفحة في Google Chrome، ووصل الحاسوب وChromecast بشبكة Wi-Fi نفسها.",
  castStepTwo: "افتح قائمة Chrome ← البث والحفظ والمشاركة ← بث.",
  castStepThree:
    "اختر بث علامة التبويب، ثم حدد مكبر الصوت أو التلفاز. اترك علامة التبويب مفتوحة أثناء الاستماع.",
  castHelp: "دليل Google للبث",
  noDevices:
    "لم يُعثر على أجهزة متوافقة بعد. تأكد من اتصال الجهازين بالشبكة نفسها.",
  deviceFailed:
    "تعذّر فتح منتقي الأجهزة. جرّب Safari لـ AirPlay أو خيار بث علامة التبويب في Chrome.",
  followShort: "متابعة",
  frequencyView: "عرض الترددات",
  seekSpeech: "الانتقال في الكلام",
  seekMusic: "الانتقال في الموسيقى",
  playerGuide: "أدوات المشغّل ودليل الاستخدام",
  zoom: "تكبير الزمن",
  zoomIn: "تكبير",
  zoomOut: "تصغير",
  fit: "الكل",
  panTimeline: "تحريك النطاق الزمني المعروض",
  spectrumSettings: "إعدادات الطيف ودليل الاستخدام",
  frequencyScale: "مقياس التردد",
  logarithmic: "لوغاريتمي",
  linear: "خطي",
  frequencyRange: "نطاق التردد",
  spectrumAveraged: "متوسط المستوى عبر الزمن محسوب من التسجيل.",
  spectrumHelp:
    "انقر للانتقال واسحب لتحريك العرض. استخدم + / − للتكبير والأسهم للانتقال وShift مع الأسهم للتحريك وCtrl مع عجلة الفأرة للتكبير.",
  spectrumCursor: "مرّر المؤشر فوق الطيف لفحص الزمن والتردد والمستوى.",
  loadingSpectrum: "جارٍ تحميل الطيف…",
  spectrumUnavailable:
    "التحليل الطيفي غير متاح لهذا التسجيل. لا يزال التشغيل متاحاً.",
  liveSubtitles: "الترجمة المباشرة",
  bandcamp: "ابحث في Bandcamp",
  copyFailed: "تعذّر نسخ الرابط. انسخ العنوان من المتصفح.",
  navigation: "التنقل",

  wheelShows: "عجلة الاستماع",
  circlePlayHint: "اختر دائرة، ثم اضغط عليها مرة أخرى للتشغيل",
  allShows: "جميع البرامج",
  fromCollection: "من المجموعة",
  rotateHint: "اسحب العجلة أو اختر برنامجاً",
  browse: "تصفّح",
  thisWeek: "هذا الأسبوع",
  weeklyShows: "برامج هذا الأسبوع الجديدة",
  onTheDial: "على الموجة",
  previousShow: "البرنامج السابق",
  nextShow: "البرنامج التالي",
  pauseRotation: "إيقاف الدوران",
  startRotation: "بدء الدوران",
  selectShow: "اختر البرنامج",
  weeklyHint: "دورة على الموجة. ركن مختلف من العالم.",
  emptyWeek:
    "لا توجد برامج مؤرخة هذا الأسبوع بعد. استكشف المجموعة في الانتظار.",
  previousSection: "المقطع السابق",
  nextSection: "المقطع التالي",
  appearance: "المظهر وإمكانية الوصول",
  layout: "التصميم",
  identity: "الاسم والشعار",
  fontFace: "نوع الخط",
  textSize: "حجم النص",
  palette: "لوحة الألوان",
  motion: "الحركة",
  readingComfort: "راحة القراءة",
  preview: "معاينة مباشرة",
  previewTitle: "أبعد قليلاً عن المألوف.",
  resetAppearance: "إعادة ضبط تفضيلات القراءة",
  appearanceSaved: "تُحفظ التغييرات في حسابك.",
  appearanceLocal:
    "تُحفظ التغييرات على هذا الجهاز. سجّل الدخول لحفظها في حسابك.",
  fontEditorial: "تحريري · خطوط متنوعة",
  fontSans: "خط النظام",
  fontHumanist: "Verdana · حروف واضحة",
  fontSerif: "Georgia · خط كلاسيكي",
  fontMono: "خط ثابت العرض",
  palette_theme: "ألوان التصميم",
  palette_linen: "كتان · ورق دافئ",
  palette_ocean: "محيط · أزرق وكريمي",
  palette_plum: "برقوق · بنفسجي ناعم",
  palette_night: "ليل · حبر داكن",
  systemMotion: "اتّباع إعداد الجهاز",
  reducedMotion: "تقليل الحركة",
  contrast: "تباين عالٍ",
  spacing: "تباعد أكبر بين السطور والحروف",
  underline: "تسطير الروابط",
  followPlayback: "متابعة التشغيل تلقائياً",
  preferenceError: "حُفظ على الجهاز؛ تعذّرت مزامنة الحساب.",
  atlas: "دليل للموجات الإذاعية",
  tide: "رف استماع متدفق",
  musicLabel: "موسيقى",
  timeline: "خريطة الصوت",
  speechMusic: "حديث فوق الموسيقى",
  unclassified: "صوت غير مصنّف",
  timelineHint:
    "مقاطع مكتشفة آلياً. قد يتداخل الحديث والموسيقى؛ اختر مقطعاً للاستماع.",
  trackFollow: "متابعة المقطع الحالي",
  transcriptHint: "اقرأ أثناء الاستماع، أو اختر سطراً للعودة إلى تلك اللحظة.",
  skipContent: "انتقل إلى المحتوى",
  discover: "اكتشف",
  new: "ما الجديد",
  shows: "البرامج",
  stations: "المحطات",
  artists: "الفنانون",
  search: "بحث",
  library: "مساحتي",
  signin: "تسجيل الدخول",
  signout: "تسجيل الخروج",
  settings: "مساحتك",
  headline: "موسيقى جريئة.\nمن أنحاء العالم.",
  intro:
    "إذاعات عامة وأصوات مستقلة. موسيقى يختارها البشر، لا الخوارزميات. اتبع فضول مقدّمين يعرفون ما يبثّونه ويحبّونه.",
  eyebrow: "إذاعات عامة جريئة من جميع أنحاء العالم",
  latest: "أحدث الإضافات",
  all: "كل البرامج",
  listen: "استمع الآن",
  play: "تشغيل",
  pause: "إيقاف مؤقت",
  queue: "أضف إلى القائمة",
  added: "أضيف إلى القائمة",
  episodes: "حلقات",
  episode: "حلقة",
  featured: "بداية الرحلة",
  explore: "اكتشف المجموعة",
  tracks: "المقاطع",
  transcript: "النص",
  notes: "ملاحظات خاصة",
  about: "عن الحلقة",
  original: "الأصل",
  translation: "الترجمة",
  bilingual: "إظهار الأصل أيضاً",
  follow: "متابعة التشغيل",
  caption: "ما يُقال الآن",
  music: "دع الموسيقى تتحدث.",
  musicHint: "تظهر الترجمة عند بدء الحديث.",
  listening: "تستمع الآن",
  openPlayer: "فتح المشغّل",
  speech: "حديث",
  sound: "موسيقى وأصوات",
  candidate: "اقتراح · غير مؤكد",
  publisher: "قائمة المحطة",
  confirmed: "مؤكد",
  unknown: "مقطوعة غير معروفة",
  language: "لغة القراءة",
  themes: "اختر منظورك",
  themeHint: "خمسة تصاميم. طريقتك في الاستماع.",
  languageHint: "لغتك ترافقك في النصوص والبحث وأوصاف البرامج.",
  translated: "ترجمة آلية",
  translating: "جارٍ ترجمة تفاصيل البرامج…",
  unavailable: "الترجمة غير متاحة. يُعرض النص الأصلي.",
  searchTitle: "اتبع خيطاً.",
  searchHint: "ابحث عن فنان أو برنامج أو مقطع أو عبارة بأي لغة.",
  searchPlaceholder: "فنان، مكان، فكرة عابرة…",
  results: "نتائج",
  noResults: "لا توجد نتائج. جرب كلمة أخرى.",
  newTitle: "إشارات جديدة.",
  newIntro: "إضافات جديدة وروابط عبر المجموعة.",
  broadcast: "تاريخ البث",
  addedDate: "تاريخ الإضافة",
  connections: "عبر الأثير",
  guest: "ضيف",
  appeared: "على",
  showsTitle: "أصوات تستحق العودة.",
  stationsTitle: "أماكن مختلفة. فضول مشترك.",
  artistsTitle: "الناس وراء الصوت.",
  saveNote: "حفظ ملاحظة خاصة",
  notePlaceholder: "فكرة، اكتشاف، لحظة للعودة إليها…",
  noteHint: "أنت وحدك ترى ملاحظاتك المرتبطة بهذا التسجيل.",
  noNotes: "تبدأ يومياتك بلحظة.",
  noteLogin: "سجّل الدخول لحفظ ملاحظة خاصة.",
  delete: "حذف",
  edit: "تعديل",
  save: "حفظ",
  cancel: "إلغاء",
  username: "اسم المستخدم",
  password: "كلمة المرور",
  createAccount: "إنشاء حساب",
  authIntro: "احتفظ بلغتك وملاحظاتك الخاصة.",
  loading: "جارٍ التحميل…",
  retry: "حاول مجدداً",
  empty: "لا توجد برامج بعد.",
  source: "البث الأصلي",
  duration: "المدة",
  languages: "اللغات المنطوقة",
  collection: "المجموعة",
  viewAll: "عرض الكل",
  next: "التالي",
  queueEmpty: "قائمة الاستماع فارغة.",
  clear: "مسح القائمة",
  remove: "إزالة",
  close: "إغلاق",
  volume: "مستوى الصوت",
  speed: "سرعة التشغيل",
  skipBack: "الرجوع ١٥ ثانية",
  skipForward: "التقدم ١٥ ثانية",
  seek: "موضع التشغيل",
  account: "الحساب",
  details: "تفاصيل البرنامج",
  focus: "غرفة الاستماع",
  exitFocus: "مغادرة الغرفة",
  captionMissing: "الترجمة غير متاحة · النص الأصلي",
  automaticHint: "النصوص والترجمات آلية وقد تحتوي على أخطاء.",
  more: "المزيد",
  copied: "نُسخ الرابط",
  share: "نسخ رابط اللحظة",
  noteSaved: "حُفظت الملاحظة الخاصة",
};
const ja: Partial<Record<Key, string>> = {
  collapsePlayer: "プレーヤーを折りたたむ",
  expandPlayer: "プレーヤーを展開",
  currentTrack: "再生中の曲",
  programmeAudio: "番組の音声",
  listenDevices: "別のデバイスで聴く",
  thisDevice: "音声出力：このデバイス",
  wirelessConnected: "ワイヤレスデバイスに接続済み",
  deviceConnecting: "接続中…",
  airplayHint:
    "同じネットワークのAirPlayスピーカーやテレビを選択します。対応状況はブラウザとデバイスによって異なります。",
  airplaySafari:
    "AirPlayを使うには、AppleデバイスのSafariでこのページを開いてください。",
  chooseAirplay: "AirPlayデバイスを選ぶ",
  chooseDevice: "ワイヤレスデバイスを選ぶ",
  castLocal:
    "このローカルプレビューの音声は、このコンピューターからのみ利用できます。Chromecastで聴くには、Google Chromeでこのタブをキャストしてください。",
  castBrowser:
    "対応ブラウザのワイヤレスデバイス選択、またはGoogle Chromeのタブキャストを利用できます。",
  castTab: "Chromeでこのタブをキャスト",
  castStepOne:
    "Google Chromeでこのページを開き、コンピューターとChromecastを同じWi-Fiに接続します。",
  castStepTwo: "Chromeのメニュー → キャスト、保存、共有 → キャストを開きます。",
  castStepThree:
    "タブをキャストを選び、スピーカーやテレビを選択します。再生中はタブを開いたままにしてください。",
  castHelp: "Googleのキャストガイド",
  noDevices:
    "対応デバイスが見つかりません。同じネットワークに接続されているか確認してください。",
  deviceFailed:
    "デバイス選択を開けませんでした。AirPlayにはSafari、またはChromeのタブキャストをお試しください。",
  followShort: "追従",
  frequencyView: "周波数表示",
  seekSpeech: "音声の再生位置",
  seekMusic: "音楽の再生位置",
  playerGuide: "プレーヤーの操作ガイド",
  zoom: "時間軸のズーム",
  zoomIn: "拡大",
  zoomOut: "縮小",
  fit: "全体",
  panTimeline: "表示する時間範囲を移動",
  spectrumSettings: "スペクトルの設定と操作ガイド",
  frequencyScale: "周波数の目盛り",
  logarithmic: "対数",
  linear: "線形",
  frequencyRange: "周波数範囲",
  spectrumAveraged: "録音から計算した時間平均レベル。",
  spectrumHelp:
    "クリックで再生位置を変更、ドラッグで表示を移動。+ / − でズーム、矢印キーで移動、Shift + 矢印でパン、Ctrl + ホイールでポインター位置を拡大。全体図で表示範囲を移動できます。",
  spectrumCursor:
    "スペクトル上にポインターを置くと時刻、周波数、レベルを確認できます。",
  loadingSpectrum: "スペクトルを読み込み中…",
  spectrumUnavailable: "この録音の周波数解析は利用できません。再生は可能です。",
  liveSubtitles: "ライブ字幕",
  bandcamp: "Bandcampで探す",
  copyFailed:
    "リンクをコピーできませんでした。ブラウザのアドレスをコピーしてください。",
  navigation: "ナビゲーション",

  wheelShows: "リスニングホイール",
  circlePlayHint: "円を選び、もう一度タップして再生",
  allShows: "すべての番組",
  fromCollection: "コレクションから",
  rotateHint: "ホイールをドラッグ、または番組を選択",
  browse: "番組一覧",
  thisWeek: "今週",
  weeklyShows: "今週の新しい番組",
  onTheDial: "ダイヤルの向こう",
  previousShow: "前の番組",
  nextShow: "次の番組",
  pauseRotation: "回転を停止",
  startRotation: "回転を開始",
  selectShow: "番組を選ぶ",
  weeklyHint: "ダイヤルを回して、世界の別の場所へ。",
  emptyWeek:
    "今週放送された番組はまだありません。コレクションをお楽しみください。",
  previousSection: "前の区間",
  nextSection: "次の区間",
  appearance: "表示とアクセシビリティ",
  layout: "レイアウト",
  identity: "名前とロゴ",
  fontFace: "フォント",
  textSize: "文字サイズ",
  palette: "配色",
  motion: "動き",
  readingComfort: "読みやすさ",
  preview: "プレビュー",
  previewTitle: "聴き慣れた世界の、その先へ。",
  resetAppearance: "読みやすさの設定をリセット",
  appearanceSaved: "変更はアカウントに保存されます。",
  appearanceLocal:
    "この端末に保存されます。ログインするとアカウントにも保存できます。",
  fontEditorial: "編集スタイル · 混植",
  fontSans: "システム · サンセリフ",
  fontHumanist: "Verdana · 開いた字形",
  fontSerif: "Georgia · セリフ",
  fontMono: "等幅 · 均等な間隔",
  palette_theme: "レイアウトの配色",
  palette_linen: "リネン · 温かな紙",
  palette_ocean: "オーシャン · 青とクリーム",
  palette_plum: "プラム · 柔らかな紫",
  palette_night: "ナイト · 深いインク",
  systemMotion: "端末の設定に従う",
  reducedMotion: "動きを減らす",
  contrast: "高コントラスト",
  spacing: "行間と文字間を広く",
  underline: "リンクに下線",
  followPlayback: "再生位置を自動追従",
  preferenceError: "この端末に保存しました。アカウントへの同期に失敗しました。",
  atlas: "ラジオをめぐるフィールドガイド",
  tide: "流れるような音楽の棚",
  musicLabel: "音楽",
  timeline: "音声マップ",
  speechMusic: "音楽に重なる話し声",
  unclassified: "未分類の音",
  timelineHint:
    "自動検出した区間です。話し声と音楽が重なる場合があります。区間を選んで再生できます。",
  trackFollow: "再生中の曲を追従",
  transcriptHint: "聴きながら読む。行を選ぶと、その時点に戻れます。",
  skipContent: "本文へ移動",
  discover: "見つける",
  new: "新着",
  shows: "番組",
  stations: "放送局",
  artists: "アーティスト",
  search: "検索",
  library: "マイリスニング",
  signin: "ログイン",
  signout: "ログアウト",
  settings: "マイスペース",
  headline: "冒険する音楽。\n世界のあちこちから。",
  intro:
    "公共ラジオと独立した声。アルゴリズムではなく、人が選ぶ音楽。曲を知り、愛するパーソナリティの耳をたよりに。",
  eyebrow: "世界中の冒険心あふれる公共ラジオ",
  latest: "最近の追加",
  all: "すべての番組",
  listen: "今すぐ聴く",
  play: "再生",
  pause: "一時停止",
  queue: "キューに追加",
  added: "追加しました",
  episodes: "エピソード",
  episode: "エピソード",
  featured: "ここから始める",
  explore: "コレクションを見る",
  tracks: "曲目",
  transcript: "文字起こし",
  notes: "自分だけのメモ",
  about: "このエピソードについて",
  original: "原文",
  translation: "翻訳",
  bilingual: "原文も表示",
  follow: "再生に追従",
  caption: "今、話していること",
  music: "音楽に耳を澄ませて。",
  musicHint: "話し声に合わせて字幕が表示されます。",
  listening: "再生中",
  openPlayer: "プレーヤーを開く",
  speech: "話し声",
  sound: "音楽と音",
  candidate: "候補・未確認",
  publisher: "放送局の曲目",
  confirmed: "確認済み",
  unknown: "未特定の曲",
  language: "表示言語",
  themes: "視点を選ぶ",
  themeHint: "5つのレイアウト。あなたらしい聴き方。",
  languageHint: "字幕、文字起こし、検索、番組紹介に反映されます。",
  translated: "自動翻訳",
  translating: "番組情報を翻訳中…",
  unavailable: "翻訳できません。原文を表示しています。",
  searchTitle: "ひとつの糸をたどる。",
  searchHint: "アーティスト、番組、曲、言葉を、どの言語でも検索。",
  searchPlaceholder: "アーティスト、場所、ふと浮かんだ言葉…",
  results: "件",
  noResults: "見つかりませんでした。別の言葉をお試しください。",
  newTitle: "新しいシグナル。",
  newIntro: "新たな番組と、コレクションをつなぐ発見。",
  broadcast: "放送日",
  addedDate: "追加日",
  connections: "番組を越えて",
  guest: "ゲスト",
  appeared: "登場する番組",
  showsTitle: "また聴きたくなる声。",
  stationsTitle: "違う場所。同じ好奇心。",
  artistsTitle: "音の向こうの人々。",
  saveNote: "メモを保存",
  notePlaceholder: "思いつき、発見、また聴きたい瞬間…",
  noteHint: "メモは自分だけに表示され、この録音に紐づきます。",
  noNotes: "ひとつの瞬間から始まるリスニング日記。",
  noteLogin: "ログインして、この瞬間にメモを残しましょう。",
  delete: "削除",
  edit: "編集",
  save: "保存",
  cancel: "キャンセル",
  username: "ユーザー名",
  password: "パスワード",
  createAccount: "アカウント作成",
  authIntro: "言語、レイアウト、自分だけのメモを保存。",
  loading: "読み込み中…",
  retry: "再試行",
  empty: "まだ番組がありません。",
  source: "元の放送を見る",
  duration: "再生時間",
  languages: "話されている言語",
  collection: "コレクション",
  viewAll: "すべて見る",
  next: "次の番組",
  queueEmpty: "キューは空です。番組を追加してください。",
  clear: "キューを消去",
  remove: "削除",
  close: "閉じる",
  volume: "音量",
  speed: "再生速度",
  skipBack: "15秒戻る",
  skipForward: "15秒進む",
  seek: "再生位置",
  account: "アカウント",
  details: "番組情報",
  focus: "リスニングルーム",
  exitFocus: "ルームを閉じる",
  captionMissing: "翻訳なし・原文を表示",
  automaticHint: "文字起こしと翻訳は自動生成のため、誤りを含む場合があります。",
  more: "さらに表示",
  copied: "リンクをコピーしました",
  share: "この瞬間のリンクをコピー",
  noteSaved: "メモを保存しました",
};
export function translator(lang: string) {
  return (key: Key) => ({ fr, ar, ja })[lang as "fr"]?.[key] ?? en[key];
}
